import { Component, Input } from '@angular/core';
import { AppState } from '../../../../app.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DpsService } from './dps-service.service';

@Component({
  selector: 'storageTrendGraph',
  providers: [TranslateService],
  styles: [require('./dps-dashboard.scss')],
  template: `
    <div *ngIf="!loaded" class="row flex-items-xs-middle content-loader">
        <div class="col-xs">
        <div class="spinner {{spinnerCls}}">
        {{ 'common.loading' | translate }}
        </div>
        </div>
    </div>
    <basic-chart *ngIf="loaded"
        chartId="myTimeSeriesChart"
        chartType="line"
        [chartData]="timeSeriesData"
        [chartOptions]="timeSeriesOptions">
    </basic-chart>
  `
})

export class StorageTrendGraph{

    public timeSeriesData : any;
    public timeSeriesOptions : any;
    storageTrend : any;
    private loaded: boolean = false;
    @Input() summaryTrendGraph: boolean = false;
    private spinnerCls: string;

    constructor(private service: DpsService, private translate: TranslateService){
        translate.use(GlobalVariables.LOCALE);
    }

    ngOnInit(){
      this.spinnerCls = this.summaryTrendGraph ? "spinner-md" :  "spinner-lg";
      this.service.getStorageTrend()
      .subscribe(
        data => {
          this.storageTrend = data;
          this.storageTrend = JSON.stringify(this.storageTrend);
          this.storageTrend = this.storageTrend.replace(/date/g, 'x');
          this.storageTrend = this.storageTrend.replace(/storageConsumed/g, 'y');
          this.storageTrend = JSON.parse(this.storageTrend);
          this.timeSeriesData = {
          datasets: [
              {
                  maintainAspectRatio: false,
                  label: this.translate.instant('vcDpsModule.dashboard.storageConsumed'),
                  fill: true,
                  backgroundColor: 'rgba(0, 161, 255, 0.18)',
                  borderColor: '#007CBB',
                  pointBackgroundColor: 'rgba(77,83,96,1)',
                  pointBorderColor: '#fff',
                  pointHoverBackgroundColor: '#fff',
                  pointHoverBorderColor: 'rgba(77,83,96,1)',
                  data: this.storageTrend
              }
          ]
        };
        this.timeSeriesOptions = {
        responsive: true,
        legend: {
            display: false,
            position: 'top'
        },
        tooltips: {
            enabled: !this.summaryTrendGraph,
            mode: 'x-axis'
        },
        scales: {
            xAxes: [{
                type: 'time',
                display: !this.summaryTrendGraph,
                position: 'bottom',
                time: {
                    unit: 'day'
                },
                scaleLabel: {
                    display: true,
                    labelString: this.translate.instant('dpsModule.dashboard.date')
                }
            }],
            yAxes: [{
                display: !this.summaryTrendGraph,
                scaleLabel: {
                    display: true,
                    labelString: this.translate.instant('vcDpsModule.dashboard.storageConsumed') + ' (MB)'
                }
            }]
        }
        };
        this.loaded = true;
        },
        error => {window.alert(error);}
      )
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/dashboard/storage-trend-graph.component.ts